<template>
  <div class="approvemy">
    <div class="we_cell">
      <div class="we_cellbd">绑定手机</div>
      <div class="we_cellft">
        <div class="btn-ok">完成</div>
      </div>
    </div>
    <div class="we_cell">
      <div class="we_cellbd">微信认证</div>
      <div class="we_cellft">
        <div class="btn-go">去认证</div>
      </div>
    </div>
    <div class="we_cell">
      <div class="we_cellbd">关注人数达到10人</div>
      <div class="we_cellft">
        <div class="btn-no">未达成</div>
      </div>
    </div>
    <div class="we_cell">
      <div class="we_cellbd">粉丝数达到10人</div>
      <div class="we_cellft">
        <div class="btn-no">未达成</div>
      </div>
    </div>
    <div class="we_cell">
      <div class="we_cellbd">发布动态内容达到7篇</div>
      <div class="we_cellft">
        <div class="btn-no">未达成</div>
      </div>
    </div>
    <div class="block_btn">
      <div class="we_btn f-14" type="primary" @click="goApprove">申请认证</div>
    </div>
    <div class="privilege">
      <div class="f-18 f-w text-c mb-20">认证特权</div>
      <div class="privilege_info f-12">
        <div>
          <img :src="img.tqicon" class="tqicon">
          特殊认证标识，与众不同
        </div>
        <div class="mt-12">
         <img :src="img.tqicon" class="tqicon">
         发布的内容可获得官方推荐，增加人气
       </div>
       <div class="c-gray text-c mt-25">更多专属权益敬请期待！</div>
     </div>
   </div>
 </div>
</template>
<script>
  import post from '../../../api/lexus/release';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon } from 'vant';
  export default {
    data () {
      return {
        img:{
          tqicon: require('../../../assets/img/subaru/approve/tqicon.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.isTabbar({state: true})
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      if(this.$route.query.token){
        this.source = this.$route.query.source
        this.token = this.$route.query.token
        this.user_id = this.$route.query.userid
        this.$store.dispatch('param/setToken', this.$route.query.token)
      }
      var params={
        event_code: '身份认证',
        event_id: '',
        title: '',
        value: '',
        path: '/Subaru/My/Approvemy.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
    },
    methods: {
      goApprove(){
        if(this.source==5||this.source==1){
          this.$router.push({name:'SubaruApproveok',params:{source:this.source,token:this.token,user_id:this.user_id}});
        }else{
          var params={
            url:this.weburl+'/subaru/approveok?source='+this.source ,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }
        
        
      }
    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Field.name]:Field,
      [Button.name]:Button,
      [Icon.name]:Icon
    }
  }
</script>
<style lang="scss">
  .approvemy{
    background-color: #F1F1F1;
    margin-top: 20px;
    .we_cell {
      display: flex;
      align-items: center;
      padding: 15px 36px;
      font-size: 12px;
      .we_cellbd {
        flex: 1;
      }
      .we_cellft {
        float: right;
        .btn-ok {
          width: 48px;
          height: 24px;
          color: #fff;
          background-color: #B4C1AB;
          justify-content: center;
          align-items: center;
          display: flex;
          border-radius: 8px;
        }
        .btn-go {
          width: 48px;
          height: 24px;
          color: #fff;
          background-color: #1F2A74;
          justify-content: center;
          align-items: center;
          display: flex;
          border-radius: 8px;
        }
        .btn-no {
          width: 48px;
          height: 24px;
          color: #fff;
          background-color: #979797;
          justify-content: center;
          align-items: center;
          display: flex;
          border-radius: 8px;
        }
      }
    }
    .we_btn {
      width: 70%;
      height: 45px;
      color: #fff;
      background-color: #1F2A74;
      justify-content: center;
      align-items: center;
      display: flex;
      border-radius: 8px;
    }
    .block_btn {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 34px;
    }
    .privilege {
      padding: 26px;
      border-top: 10px solid #F8F8F8;
      .mb-20{
        margin-bottom: 20px;
      }
      .mt-12{
        margin-top: 12px;
      }
      .mt-25{
        margin-top: 25px;
      }
      .privilege_info {
        padding: 26px 17px;
        background-color: #FFFFFF;
        .tqicon {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
</style>
